<div class="item-list-content">
    @for(item of currentStepItems(); track item){
        <cwo-special-item (itemSelected)="onItemSelected($event)" [selected]="isSelected(item)" [item]="item" />
    }
</div>